import { render, staticRenderFns } from "./PhotoView.vue?vue&type=template&id=70a97cd7&"
import script from "./PhotoView.vue?vue&type=script&lang=js&"
export * from "./PhotoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports